// extracted by mini-css-extract-plugin
export default {"sr-only":"Checkbox__sr-only--fbdwa Accessibility__sr-only--fRyoV","default":"Checkbox__default--Z3AGn"};